import location from '../app-data/location';
import { env } from '../env';

/**
 * env().performance wrappers
 */
export default {
  getNavigation() {
    return typeof env() !== 'undefined' && env().performance
      ? env().performance.navigation
      : {};
  },

  /**
   * get all loaded resources
   */
  getResources() {
    const emptyVal = [];
    try {
      return (
        (env() &&
          env().performance &&
          env().performance.getEntriesByType &&
          env().performance.getEntriesByType('resource')) ||
        emptyVal
      );
    } catch (e) {
      return emptyVal;
    }
  },

  getTiming() {
    return env() && env().performance ? env().performance.timing : {};
  },

  clearResourceTimings() {
    env() &&
      env().performance &&
      env().performance.clearResourceTimings &&
      env().performance.clearResourceTimings();
  },

  /**
   * Duration relative to navigation start (env().performance.timing.navigationStart)
   * fallback to: performance.now -> now (nodejs) -> getTime()
   */
  now() {
    if (env() && env().performance && env().performance.now) {
      return env().performance.now();
    } else if (
      typeof performance !== 'undefined' &&
      performance &&
      performance.now
    ) {
      return performance.now();
    }

    return new Date().getTime();
  },

  /**
   * Create a performance timestamp
   */
  mark(name) {
    if (location.isFedopsDev()) {
      env() &&
        env().performance &&
        env().performance.mark &&
        env().performance.mark(name);
    }
  },

  /**
   * Record a performance measurement
   */
  measure(name, startMark, endMark) {
    if (location.isFedopsDev()) {
      env() &&
        env().performance &&
        env().performance.measure &&
        env().performance.measure(name, startMark, endMark);
    }
  },
};
